"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const tyre_search_1 = require("../../components/ProductSearch/tyre-search");
const TyreFilter_vue_1 = __importDefault(require("../../components/ProductSearch/TyreFilter.vue"));
const forms_1 = require("../../components/ProductSearch/forms");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const SearchInput_vue_1 = __importDefault(require("../../components/Form/SearchInput/SearchInput.vue"));
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const i18n_1 = require("../../common/i18n");
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductRimsBySize',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const currentType = (0, vue_3.ref)("rim");
        const mainCategorySelectedItem = (0, vue_3.ref)("445");
        const mainCategoryItems = (0, vue_3.ref)([
            new DropdownInputItem_1.default("445", `${(0, i18n_1.trans)("alloyRim", "Alloy rim", "rim_filter")}`),
            new DropdownInputItem_1.default("440", `${(0, i18n_1.trans)("steelRim", "Steel rim", "rim_filter")}`),
            new DropdownInputItem_1.default("420", `${(0, i18n_1.trans)("forklift", "Forklift", "rim_filter")}`),
            new DropdownInputItem_1.default("415", `${(0, i18n_1.trans)("twinWheels", "Twin wheels", "rim_filter")}`),
            new DropdownInputItem_1.default("410", `${(0, i18n_1.trans)("agriculturalRim", "Agricultural rim", "rim_filter")}`),
            new DropdownInputItem_1.default("530", `${(0, i18n_1.trans)("valve", "Valve", "rim_filter")}`),
        ]);
        const brandDropdownInputItems = (0, vue_3.computed)(() => productFilterStore.brandDropdownInputItems);
        const filterValues = (0, vue_3.computed)(() => productFilterStore.productFilters);
        const manufacturerSkus = (0, vue_3.computed)(() => productFilterStore.manufacturerSkuSearchInputOptions);
        const initForm = (mainCategory) => {
            let type = (0, forms_1.calculateTypeFromAxCategory)(mainCategory);
            currentType.value = type;
            let _form = { axCategory: [mainCategory] };
            if ("rim" == type) {
                _form = Object.assign(forms_1.rimProductSearchForm, _form);
            }
            if ("valve" == type) {
                _form = Object.assign(forms_1.valveProductSearchForm, _form);
            }
            return _form;
        };
        let form = (0, vue_3.ref)(Object.assign({}, initForm(mainCategorySelectedItem.value)));
        const manufacturerSkuDisplayValue = (0, vue_3.ref)("");
        const manufacturerSkuSearchInput = (0, vue_3.ref)(null);
        const initQueryParams = (0, tyre_search_1.getQueryParams)(form.value, route);
        for (const key in initQueryParams) {
            if (initQueryParams.hasOwnProperty(key)) {
                if (key === "axCategories") {
                    mainCategorySelectedItem.value = initQueryParams[key][0];
                    form.value['axCategory'] = initQueryParams[key];
                }
                if (key === "type") {
                    currentType.value = initQueryParams[key];
                }
                form.value[key] = initQueryParams[key];
                if (key === "manufacturerSku") {
                    manufacturerSkuDisplayValue.value = initQueryParams[key];
                }
            }
        }
        (0, vue_3.watch)(() => mainCategorySelectedItem.value, (mainCategory) => {
            for (const key in form.value) {
                if (form.value.hasOwnProperty(key)) {
                    if (key === "axCategory") {
                        form.value.axCategory = [mainCategory];
                        continue;
                    }
                    if (key === "type") {
                        currentType.value =
                            (0, forms_1.calculateTypeFromAxCategory)(mainCategory);
                        form.value[key] = currentType.value;
                        continue;
                    }
                    form.value[key] = null;
                }
            }
        });
        const manufacturerSkuSelected = (selectedManufacturerSkuOption) => {
            form.value.manufacturerSku = selectedManufacturerSkuOption.value;
        };
        const manufacturerSkuReset = () => {
            delete form.value.manufacturerSku;
        };
        (0, vue_3.watch)(() => form.value.axCategory, () => {
            if (manufacturerSkuSearchInput.value === null) {
                return;
            }
            manufacturerSkuSearchInput.value.reset();
        }, { deep: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreFilter_vue_1.default, {
                searchLabel: (0, vue_2.unref)(i18n_1.trans)('rim_search', 'Rims search by size', 'rim_search'),
                form: (0, vue_2.unref)(form),
                placeholder: (0, vue_2.unref)(i18n_1.trans)('tag_search_input_placeholder', 'eg. kronprinz', 'rim_search'),
                "need-tag-search": true,
                category: currentType.value
            }, {
                filtersPrepend: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('category', 'Category', 'search_form'),
                        items: mainCategoryItems.value,
                        modelValue: mainCategorySelectedItem.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((mainCategorySelectedItem).value = $event)),
                        "disable-deselect": ""
                    }, null, 8, ["placeholder", "items", "modelValue"])
                ]),
                defaultFilters: (0, vue_2.withCtx)(() => {
                    var _a, _b;
                    return [
                        ('rim' == currentType.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownInput_vue_1.default, {
                                key: 0,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('width', 'Width', 'tyre_filter'),
                                items: (_a = (0, vue_2.unref)(filterValues)) === null || _a === void 0 ? void 0 : _a.widths.values,
                                modelValue: (0, vue_2.unref)(form).width,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((0, vue_2.unref)(form).width = $event))
                            }, null, 8, ["placeholder", "items", "modelValue"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        ('rim' == currentType.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownInput_vue_1.default, {
                                key: 1,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'tyre_filter'),
                                items: (_b = (0, vue_2.unref)(filterValues)) === null || _b === void 0 ? void 0 : _b.diameters.values,
                                modelValue: (0, vue_2.unref)(form).diameter,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((0, vue_2.unref)(form).diameter = $event))
                            }, null, 8, ["placeholder", "items", "modelValue"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        ('rim' == currentType.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownInput_vue_1.default, {
                                key: 2,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('brand', 'Brand', 'tyre_filter'),
                                items: (0, vue_2.unref)(brandDropdownInputItems),
                                modelValue: (0, vue_2.unref)(form).brandCode,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((0, vue_2.unref)(form).brandCode = $event))
                            }, null, 8, ["placeholder", "items", "modelValue"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)(SearchInput_vue_1.default, {
                            ref_key: "manufacturerSkuSearchInput",
                            ref: manufacturerSkuSearchInput,
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('manufacturer_sku_searcher_placeholder', 'SKU', 'rim_search'),
                            options: (0, vue_2.unref)(manufacturerSkus),
                            "display-value": manufacturerSkuDisplayValue.value,
                            onSelected: manufacturerSkuSelected,
                            onReset: manufacturerSkuReset
                        }, null, 8, ["placeholder", "options", "display-value"])
                    ];
                }),
                _: 1
            }, 8, ["searchLabel", "form", "placeholder", "category"]));
        };
    }
});
